<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold primary--text pa-3 d-md-flex align-center" width="100%">
      <div class="title primery--text">  {{ $t('pos.section') }} </div>
    </div>

    <v-flex xs12>
      <v-row justify="center">
        <v-col md="8">
          <v-row>
            <v-col cols="12">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col>
                     {{ $t('pos.title') }}
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        :label="$t('pos.select')"
                        :items="pointSale"
                        v-model="form.pos.point"
                        @change="loadSalePoint"
                        return-object
                      />
                    </v-col>
                    <div v-if="form.pos.point == 'Wansoft'">
                      <v-row>
                        <v-col cols="12">
                          <v-alert type="info">
                             {{ $t('pos.description') }}
                          </v-alert>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            dense
                            rounded
                            outlined
                            hide-details
                            :rules="rules.wansoftId"
                            :label="$t('pos.pointSales.wansoft.wansoftId')"
                            v-model="form.wansoftId"/>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            dense
                            rounded
                            outlined
                            hide-details
                            :rules="rules.wansoftPwd"
                            :label="$t('pos.pointSales.wansoft.wansoftPwd')"
                            v-model="form.wansoftPwd"/>
                        </v-col>
                      </v-row>
                      <v-row justify="end">
                        <v-col cols="4">
                          <v-btn
                            class="mr-3"
                            rounded
                            small
                            depressed
                            color="primary"
                            :disabled="(!form.wansoftId || !form.wansoftPwd)"
                            @click="submit">
                           {{$t('pos.btn.save')}}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
export default {
  name: 'PointSale',
  data () {
    return {
      overlay: false,
      taxInformationFormValid: false,
      pointSale: ['Wansoft'],
      form: {
        pos: {
          point: ''
        },
        wansoftId: '',
        wansoftPwd: ''
      },
      rules: {
        wansoftId: [v => !!v || this.$t('validations.wansoftId')],
        wansoftPwd: [v => !!v || this.$t('validations.wansoftPwd')]
      }
    }
  },
  computed: {
    restaurantId: function () { return this.$store.state.currentRestaurant.data._id || null }
  },
  methods: {
    async submit () {
      this.overlay = true
      try {
        const form = new FormData()
        form.append('wansoftId', this.form.wansoftId)
        form.append('wansoftPwd', this.form.wansoftPwd)
        await this.$api.post(`/v1/point-sale/${this.$store.state.currentRestaurant.data._id}`, form)
        this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async loadSalePoint () {
      if (this.form.pos.point === 'Wansoft') {
        const restaurant = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`)
        this.form.wansoftId = restaurant.wansoftId
        this.form.wansoftPwd = restaurant.wansoftPwd
      }
    }
  }
}
</script>
